import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { withPixelLineHeight } from '../../base/styles/functions.web';
import Select from '../../base/ui/components/web/Select';
import { isMobileBrowser } from "../../base/environment/utils";
import { useSelector } from "react-redux";
import SelectMobile from "../../base/ui/components/web/SelectMobile";
const useStyles = makeStyles()(theme => {
    return {
        textSelector: {
            width: '100%',
            boxSizing: 'border-box',
            borderRadius: theme.shape.borderRadius,
            backgroundColor: theme.palette.uiBackground,
            padding: '10px 16px',
            textAlign: 'center',
            ...withPixelLineHeight(theme.typography.bodyShortRegular),
            border: `1px solid ${theme.palette.ui03}`
        }
    };
});
const DeviceSelector = ({ devices, hasPermission, id, isDisabled, label, icon, onSelect, selectedDeviceId }) => {
    const { classes } = useStyles();
    const { t } = useTranslation();
    const isMobile = useSelector(() => isMobileBrowser());
    const _onSelect = useCallback((e) => {
        const deviceId = e.target.value;
        if (selectedDeviceId !== deviceId) {
            onSelect(deviceId);
        }
    }, [selectedDeviceId, onSelect]);
    const _createDropdown = (options, isMobile) => {
        const triggerText = (options.defaultSelected && (options.defaultSelected.label ? cleanLabel(options.defaultSelected.label) : options.defaultSelected.deviceId))
            || options.placeholder;
        if (options.isDisabled || !options.items?.length) {
            return (React.createElement("div", { className: classes.textSelector }, triggerText));
        }
        if (isMobile) {
            return (React.createElement(SelectMobile, { id: id, onSelect: onSelect, options: options.items, icon: icon, value: selectedDeviceId, isLanguages: false }));
        }
        return (React.createElement(Select, { id: id, onChange: _onSelect, options: options.items, icon: icon, value: selectedDeviceId }));
    };
    const _renderNoDevices = () => _createDropdown({
        isDisabled: true,
        placeholder: t('settings.noDevice')
    }, isMobile);
    const _renderNoPermission = () => _createDropdown({
        isDisabled: true,
        placeholder: t('deviceSelection.noPermission')
    }, isMobile);
    if (hasPermission === undefined) {
        return null;
    }
    if (!hasPermission) {
        return _renderNoPermission();
    }
    if (!devices?.length) {
        return _renderNoDevices();
    }
    const cleanLabel = (label) => {
        if (label === undefined) {
            return "";
        }
        return label.replace(/\([a-zA-Z0-9]{1,10}:[a-zA-Z0-9]{1,10}\)/, '').trim();
    };
    const items = devices.map(device => {
        return {
            value: device.deviceId,
            label: device.label ? cleanLabel(device.label) : device.deviceId
        };
    });
    const defaultSelected = devices.find(item => item.deviceId === selectedDeviceId);
    return _createDropdown({
        defaultSelected,
        isDisabled,
        items,
        placeholder: t('deviceSelection.selectADevice')
    }, isMobile);
};
export default DeviceSelector;
